import React, {useEffect, useMemo, useReducer, useRef, useState} from 'react'
import useQueryPostDetail from '../../../../hooks/api/post/useQueryPostDetail'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizImage from '../../../../components/image/WizImage'
import WizSelect from '../../../../components/select/WizSelect'
import TextArea from '../../../../components/input/TextArea'
import ic_plus from '../../../../assets/images/ic_plus.png'
import ic_trash from '../../../../assets/images/icon_trash.png'
import WizButton from '../../../../components/button/WizButton'
import {postUploadImage} from '../../../../apis/image/postUploadImage'
import {postEditPost} from '../../../../apis/post/editPost'
import DeletePostModal from './DeletePostModal'
import useNavigation from '../../../../hooks/useNavigation'
import Text from '../../../../components/text/Text'
import useQueryUserDetail from '../../../../hooks/api/user/useQueryUserDetail'

interface IProps {
    className?: string
    postId?: string
}

const initState = {
    title: '',
    content: '',
    channel: '',
    visibility: 0,
}

const PostDetailContainer: React.FC<IProps> = ({className, postId}) => {
    const {goPostList} = useNavigation()
    const {data: postData} = useQueryPostDetail(postId)
    const [imageList, setImageList] = useState(postData?.images || [])
    const [state, dispatch] = useReducer(reducer, initState)
    const {title, content, channel, visibility} = state

    const {data, refetch} = useQueryUserDetail(localStorage?.getItem('wiz-admin-userId'))

    function reducer(state, action) {
        switch (action.type) {
            case 'field_reset':
                return {
                    ...state,
                    title: postData?.title,
                    content: postData?.content,
                    channel: postData?.channel,
                    visibility: postData?.visibility,
                }
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    useEffect(() => {
        dispatch({type: 'field_reset'})
        setImageList(postData?.images)
    }, [postData])

    const onChangeImage = async e => {
        const imageFile = e?.target?.files[0]
        if (imageFile) {
            const result = await postUploadImage(imageFile)
            setImageList([...imageList, result?.image_url])
        }
    }

    const onClickRemoveImage = image => {
        setImageList(imageList.filter(item => item !== image))
    }

    const editSubmitPost = async () => {
        await postEditPost({
            id: postData?.id,
            title: title,
            content: content,
            channel: channel,
            visibility: visibility,
            images: imageList,
        }).then(() => {
            alert('Edit Post Complete')
            goPostList()
        })
    }

    const onClickDeletePost = async () => {
        deletePostModalRef?.current?.show()
    }

    const imageRef = useRef<any>()
    const deletePostModalRef = useRef<any>()

    const isNotMatchUser = useMemo(() => {
        return postData?.user_id !== data?.id
    }, [postData, data])
    return (
        <>
            <div className={'my-[30px] '}>
                <div className={'flex gap-x-[10px] sm:flex-col sm:gap-y-[10px]'}>
                    <div>
                        <Text className={'text-ti3'}>Now Login Account</Text>
                        <div
                            className={`flex items-center gap-x-[5px] mt-[7px] px-[30px] py-[10px] border rounded-[5px] text-center w-fit ${
                                isNotMatchUser ? 'border-font_red bg-bg_red' : 'border-line02 bg-white'
                            }`}>
                            <WizImage
                                src={`${data?.thumbnail}?type=webp&width=1000&quality=100`}
                                className={'w-[36px] h-[36px] rounded-full'}
                            />
                            <Text className={`text-ti2 ${isNotMatchUser && 'text-font_red'}`}>{data?.name}</Text>
                        </div>
                    </div>
                    {isNotMatchUser && (
                        <Text className={'text-font_red text-body3 hidden sm:block'}>
                            Writer and Login User Not Match!
                        </Text>
                    )}
                    <div>
                        <Text className={'text-ti3'}>Post Write User</Text>
                        <div
                            className={
                                'flex items-center gap-x-[5px] bg-white mt-[7px] px-[30px] py-[10px] border border-line02 rounded-[5px] text-center w-fit'
                            }>
                            <WizImage
                                src={`${postData?.user?.thumbnail}?type=webp&width=1000&quality=100`}
                                className={'w-[36px] h-[36px] rounded-full'}
                            />
                            <Text className={'text-ti2'}>{postData?.user?.name}</Text>
                        </div>
                    </div>
                </div>
                {isNotMatchUser && (
                    <Text className={'text-font_red text-body3 sm:hidden'}>Writer and Login User Not Match!</Text>
                )}
            </div>
            <div className={'flex gap-x-[10px] sm:relative sm:grid sm:grid-cols-2 sm:gap-x-[10px] sm:gap-y-[20px]'}>
                <WizSelect
                    optionKey="channel"
                    value={channel}
                    onChange={e => {
                        dispatch({
                            type: 'field_update',
                            field: 'channel',
                            value: e,
                        })
                    }}
                    buttonClassName={'sm:w-full'}
                />
                <WizSelect
                    optionKey="visibility"
                    value={visibility}
                    onChange={e => {
                        dispatch({
                            type: 'field_update',
                            field: 'visibility',
                            value: e,
                        })
                    }}
                    buttonClassName={'sm:w-full'}
                />
                <WizButton
                    text={'Delete'}
                    size={'small'}
                    type={'red'}
                    onClick={() => onClickDeletePost()}
                    className={''}
                />
                <WizButton
                    text={'Go Post'}
                    size={'small'}
                    type={'primary'}
                    onClick={() => {
                        window.open(`https://leagueoftraders.io/post/${postData?.id}`)
                    }}
                    className={''}
                />
            </div>
            <div className={'mt-[30px] space-y-[60px] p-[40px] bg-white rounded-[10px] shadow-normal sm:p-[20px]'}>
                <div>
                    <UnderLineInput
                        value={title}
                        onChanged={text => dispatch({type: 'field_update', field: 'title', value: text})}
                    />
                </div>
                <div>
                    <TextArea
                        value={content}
                        onChanged={text => dispatch({type: 'field_update', field: 'content', value: text})}
                        textAreaClassName={'h-[600px]'}
                    />
                </div>
            </div>
            <div className={'mt-[30px] p-[40px] bg-white rounded-[10px] shadow-normal sm:p-[20px]'}>
                <div className={'flex space-x-[20px] items-center'}>
                    {imageList?.map(item => {
                        return (
                            <div className={'relative'}>
                                <WizImage
                                    src={`${item}?type=webp&width=1000&quality=100`}
                                    className={'w-[200px] rounded-[10px]'}
                                />
                                <div className={'absolute top-[-15px] right-[-15px]'}>
                                    <WizImage
                                        onClick={() => onClickRemoveImage(item)}
                                        src={ic_trash}
                                        className={
                                            'bg-white w-[30px] p-[3px] rounded-full border border-line02 cursor-pointer'
                                        }
                                    />
                                </div>
                            </div>
                        )
                    })}
                    <div>
                        <WizImage
                            src={ic_plus}
                            className={'w-[60px] cursor-pointer'}
                            onClick={() => imageRef?.current.click()}
                        />
                        <input type={'file'} onChange={e => onChangeImage(e)} ref={imageRef} className={'hidden'} />
                    </div>
                </div>
            </div>

            <div className={'text-center mt-[30px]'}>
                <WizButton text={'Edit Post'} size={'big'} onClick={() => editSubmitPost()} />
            </div>

            <DeletePostModal id={postData?.id} ref={deletePostModalRef} />
        </>
    )
}

export default PostDetailContainer
